var render = function render(){var _vm=this,_c=_vm._self._c;return _c('smart-dialog',{attrs:{"title":"Édition"},model:{value:(_vm.task.editDialog),callback:function ($$v) {_vm.$set(_vm.task, "editDialog", $$v)},expression:"task.editDialog"}},[_c('task-edit',{attrs:{"task":_vm.task},on:{"saved":function($event){_vm.task.editDialog = false; _vm.save()},"change":_vm.change}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }